<template>
  <div>
    <UserActionsWrap form-title="Forgot<br> your password?">
      <RecoveryForm />
    </UserActionsWrap>
    <UserActionsNavigation />
   <!-- <BottomPanel button-text="Send" />-->
  </div>
</template>

<script>
  import UserActionsWrap from "../components/UserActionsWrap";
  import RecoveryForm from "../components/RecoveryForm";
  import UserActionsNavigation from "../components/UserActionsNavigation";
  import BottomPanel from "../components/BottomPanel";

  export default {
    name: "Recovery",
    components: {
      UserActionsWrap,
      BottomPanel,
      RecoveryForm,
      UserActionsNavigation
    }
  }
</script>
